import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var BluetoothSearching = createReactComponent("BluetoothSearching", ["svg", defaultAttributes, [["path", {
  d: "M7 7l10 10-5 5V2l5 5L7 17",
  key: "1vkd5p"
}], ["path", {
  d: "M20.83 14.83a4 4 0 000-5.66",
  key: "dfdwxo"
}], ["path", {
  d: "M18 12h.01",
  key: "1txspt"
}]]]);
export default BluetoothSearching;